<lib-dialog
  acceptButtonLabel="Продолжить"
  closeButtonLabel="Отказаться"
  header="Внимание!"
  styleClass="regulation-window"
  [hasAcceptButton]="true"
  [(visible)]="visible"
  (hideDialog)="close($event)"
  (accept)="continue.emit()"
>
  <div *ngIf="visible" class="my-container">
    <div class="modal-header">
      <p class="modal-header-text"><strong>Уважаемый клиент!</strong></p>
      <br />
      <p class="modal-header-text">
        <strong
          >Перед началом работы ознакомьтесь с Регламентом работы информационно-аналитических
          сервисов (далее - Регламент).</strong
        >
      </p>
      <p class="modal-header-text">
        <strong
          >Использование настоящих сервисов означает Ваше присоединение к Регламенту и согласие с
          его условиями. В случае отказа от присоединения к Регламенту доступ к сервисам будет
          ограничен.</strong
        >
      </p>
    </div>
    <div class="modal-pdf-viewer" [class.modal-pdf-viewer--not-supported]="isIe">
      <object [data]="pdfUrl" type="application/pdf" width="100%" height="100%">
        <embed [src]="pdfUrl" type="application/pdf" />
        <p>
          Этот браузер не поддерживает просмотр PDF. Пожалуйста, скачайте PDF-файл регламента для
          ознакомления.
        </p>
      </object>
    </div>
    <div class="modal-footer">
      <div class="download-pdf-link">
        <a [href]="pdfUrl" download>Скачать файл PDF</a>
      </div>
    </div>
  </div>
</lib-dialog>
